import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import DateTime from 'react-datetime'
import MultiSelect from "react-multi-select-component";
import SampleExcel from '../../../images/marksSample.xls';
import MarksExcelContainer from './marksExcelContainer';
import { ExcelRenderer } from 'react-excel-renderer';
import * as Cookies from "es-cookie";
import './_studentMarks.scss';
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";
import { getAuthorizedBranchIds } from "../../utils/authHelper";

// /student/marks-upload → "offline_marks_uploading". Match on module_key only.
// The section that opens this modal already gates the opener; this file re-checks at the
// submit, because that's where the addExamCategory mutation actually fires.
const MARKS_UPLOAD_MODULE = ["offline_marks_uploading"];

const ADD_EXAM_CATEGORY = gql`
  mutation($params: AddExamCategory) {
    addExamCategory(params: $params)
  }`


class CreateExamCategory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue: "",
            class: "",
            exam: "",
            branch: "",
            branchError: "",
            classError: "",
            examError: "",
            submitError: "",
            examName: "",
            examNameError: "",
            startdate: "",
            dateError: "",
            rows: [],
            cols: [],
            dataClear: 0,
            examType: "",
            examTypeError: "",
            subjectValue: [],
            qbsearchsubject: [],
            offlinesubjectsArray: [],
            StudentsMarksData: [],
            fileError: "",
            marksArray: [],
            loadingSpinner: 0,
            currentStep: 1,
            marksError: "",
            getExams: [],
            getClasses: [],
            isSubmitting: false,
            accessDeniedShow: false,
        }

        // componentDidUpdate re-seeds a copy of this state on open; accessDeniedShow is
        // deliberately absent from that reset, so it survives.
        this.guard = attachModuleGuard(this, MARKS_UPLOAD_MODULE);
    }


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ dataClear: 1, branch: "", StudentsFilterData: [], rows: [], class: "", exam: "", classError: "", examError: "", submitError: "", startdate: "", dateError: "", examType: "", examTypeError: "", marksArray: [], subjectValue: [], subjectError: "", examName: "", examNameError: "", qbsearchsubject: [], getExams: [], getClasses: [], getSubjects: [], isSubmitting: false })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;



        let getArray = [];

        if (name == "branch") {

            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    getExams: getArray,
                    branchError: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    branch: value,
                    exam: "",
                    getClasses: [],
                    class: "",
                    offlinesubjectsArray: []
                })
            } else {
                this.setState({
                    getExams: [],
                    getClasses: [],
                    class: "",
                    branch: "",
                    exam: "",
                    examName: "",
                    branchError: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    offlinesubjectsArray: []
                })
            }
        } else if (name == "exam") {

            if (value != "0") {

                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    getClasses: getArray,
                    branchError: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    exam: value,
                    offlinesubjectsArray: [],
                    class: ""
                })

                this.subjectFunction(value)
            } else {
                this.setState({
                    getClasses: [],
                    class: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    offlinesubjectsArray: []

                })
            }



        } else if (name == "class") {

            if (value != "0") {
                this.setState({
                    branchError: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    class: value,
                    offlinesubjectsArray: []

                })
            } else {
                this.setState({
                    branchError: "",
                    classError: "",
                    examError: "",
                    examNameError: "",
                    subjectError: "",
                    class: "",
                    offlinesubjectsArray: []

                })
            }

        }

    };


    subjectFunction = (value) => {
        let subjects = this.props.globals.exams.filter((item) => item.id == value);

        let subjectsArray = []

        subjects[0].exam_subjects.map((item) => {
            let filteredSubjects = this.props.globals.offlineExamSubjects.filter((item1) => item1.id == item.subject_id);

            const newObj = {
                value: filteredSubjects[0].id,
                label: filteredSubjects[0].subject
            }
            subjectsArray.push(newObj)
        })
        this.setState({ offlinesubjectsArray: subjectsArray })

    }


    handleNameChange = (event) => {
        this.setState({
            examName: event.target.value,
            examNameError: ""
        })
    }

    datefunction = (moment1, name) => {
        //console("datefunction", moment1._d, name);
        let date = String(moment1._d);
        var res = date.substr(4, 20);
        this.setState({ startdate: res });

        this.setState({
            submitError1: ""
        });
    }

    handleFileChange = e => {

        //console("eeee", e);
        this.setState({
            StudentsFilterData: [],
            cols: []
        });
        let fileObj = e.target.files[0];
        let fileType = ['application/vnd.ms-excel'];

        if (!fileType.includes(fileObj.type)) {
            this.setState({
                fileError: "Invalid Format"
            });
            return ""
        }

        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            //console("res", resp);
            if (err) {
                //console(err);
            }
            else {
                let studentMarksData = []

                if (resp.rows) {
                    let rowData = resp.rows.slice(1);
                    if (rowData) {
                        rowData.map(item => {
                            this.state.subjectValue.map((item2, index) => {
                                studentMarksData.push({ student_mobile: item[1].toString(), subject_id: item2.value, marks: item[index + 2] })
                            })
                        });
                    }
                }
                this.setState({
                    StudentsMarksData: studentMarksData,
                    fileError: ""
                });
            }
        });

    }

    handleMultipleSelectInputChange = (e, name) => {

        //console("handleMultipleSelectInputChange", e, name);

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let handlemarksArray = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    //console("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    const marksObj = {
                        subject_id: qbtopicval.value,
                        total_marks: 0
                    }

                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                    handlemarksArray.push(marksObj)
                }
                this.setState({
                    subjectValue: qbsearchtopicvalue,
                    qbsearchsubject: qbsearchtopic,
                    marksArray: handlemarksArray,
                    subjectError: ""
                });
            }
        }
    }

    validateField(fieldName, value) {
        let classError = this.state.classError;
        let examError = this.state.examError;
        let classvalue = this.state.class;
        let examValue = this.state.exam
        let branchError = this.state.branchError;
        let branchValue = this.state.branch
        let examNameValue = this.state.examName;
        let examNameError = this.state.examNameError


        switch (fieldName) {
            case "branch":
                if (value == 0) {
                    branchError = "Please select branch";
                } else {
                    branchError = "";
                }
                break;

            // case "class":
            //     if (value == 0) {
            //         classError = "Please select class";
            //         classvalue = "";

            //     } else {
            //         classError = "";
            //     }
            //     break;

            case "exam":
                if (value == 0) {
                    examError = "Please Select exam";
                } else {
                    examError = "";
                }
                break;


            case "examName":
                if (value == "") {
                    examNameError = "Give Exam name";
                } else {
                    examNameError = "";
                }
                break;
            default:
                break;
        }
        this.setState({
            classError: classError,
            examError: examError,
            class: classvalue,
            exam: examValue,
            branchError: branchError,
            branch: branchValue,
            examName: examNameValue,
            examNameError: examNameError,
            examNameValue: examNameValue

        });
    }

    handleMarksChange = async (e, id) => {
        const name = e.target.name;
        const value = e.target.value

        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        await delay(100);

        //console("handleMarksChange", name, value, id)

        let array = [];

        if (value < 0) {
            this.setState({ marksError: "Please enter valid marks" })
            return ""
        } else {
            this.setState({ marksError: "" })
        }

        this.state.marksArray.map((item) => {
            //console("item", item)
            if (item.subject_id == id) {
                array.push({ ...item, total_marks: value })
            } else {
                array.push({ ...item })
            }
        })
        this.setState({ marksArray: array })
    }

    handleFormSubmit = e => {
        // Checked ahead of the field validation, so a role without is_edit is told they
        // lack access rather than being sent to fix a form they can't submit.
        if (!this.guard.requireEdit()) return "";

        if (this.state.branch == "") {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }

        if (this.state.exam == "") {
            this.setState({ examError: "Please select Exam" })
            return ""
        }

        if (this.state.examName == "") {
            this.setState({ examNameError: "Please give Exam name" })
            return ""
        }

        if (this.state.subjectValue == "") {
            this.setState({ subjectError: "Please select Subject" })
            return ""
        }

        let is_return = false;


        this.state.marksArray.map((item) => {
            if (item.total_marks == "" || item.total_marks == 0) {
                this.setState({ marksError: "Please enter valid marks" })
                is_return = true;
                return "";
            }
        });


        if (is_return) {
            return "";
        }


        let subjectwiseMarks = [];

        this.state.marksArray.map((item) => {
            subjectwiseMarks.push({ subject_id: item.subject_id, total_marks: parseInt(item.total_marks) })
        })

        this.setState({
            isSubmitting: true
        })

        let params = {
            exam_category_name: this.state.examName.toString(),
            exam_id: parseInt(this.state.exam),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            subject_wise_marks: subjectwiseMarks,
        };

        this.setState({ loadingSpinner: 1 })

        this.addExamCategory1(params).catch(error => {
            //console("catch if error");
            //console(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpinner: 0
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)
            );
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    };

    // Last gate before addExamCategory leaves the client.
    addExamCategory1 = async params => {
        if (!this.guard.requireEdit()) return;

        //console("child");
        await this.props.addExamCategory({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addExamCategory) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
        window.location.reload(false);
    };

    handleDateChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "startdate") {
            this.setState({ startdate: Math.floor(new Date(value).getTime() / 1000) })
        }
    }

    render() {
        //console("mahesh", this.state);

        if (this.props.globals == undefined) return null;

        // Restrict the branch dropdown to branches the logged-in user is authorized for.
        // The branch_id cookie holds them as a comma-separated list (e.g. "10,12,15").
        let branchList = this.props.globals.globalBranches || [];
        const authorizedIds = getAuthorizedBranchIds();
        if (authorizedIds.length) {
            branchList = branchList.filter((item) => authorizedIds.includes(String(item.id)));
        }

        let subjectSelectAll = true;
        let subjectlabelledby = "Select";
        let subjectdisablesearch = false;
        if (this.state.offlinesubjectsArray.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectlabelledby = "Subjects"
        }


        return (
            <>
                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="example-modal-sizes-title-lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Create Exam Pattern </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4" style={{ minHeight: "400px" }}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {branchList.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Exam</Form.Label>
                                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                        <option value={this.state.defaultvalue}>--Select Exam--</option>
                                        {this.state.getExams.map(item => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={12} sm={12} controlId="examName">
                                    <Form.Label className="text-uppercase">Pattern Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Pattern Name"
                                        name="exam_name"
                                        autoComplete="off"
                                        className='custom_selection'
                                        onChange={(e) => this.handleNameChange(e)}
                                        value={this.state.examName}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examNameError}
                                    </Form.Text>
                                </Form.Group>


                                <Form.Group as={Col} xl={3} lg={4} md={6} sm={12} controlId="SelectSubject">
                                    <Form.Label className="text-uppercase">Select Subject</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Subjects are selected.",
                                            "selectSomeItems": subjectlabelledby
                                        }
                                        }
                                        disableSearch={subjectdisablesearch}
                                        hasSelectAll={subjectSelectAll}
                                        options={this.state.offlinesubjectsArray}
                                        value={this.state.subjectValue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "subjects")}
                                        labelledBy={"Subjects"}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.subjectError}
                                    </Form.Text>
                                </Form.Group>


                            </Form.Row>

                            {
                                this.state.subjectValue.length > 0 ?
                                    (
                                        <Form.Row>
                                            <Form.Label>Enter Subject wise Total Marks</Form.Label>

                                        </Form.Row>
                                    )
                                    :
                                    ("")
                            }

                            <Form.Row className="">
                                {
                                    this.state.subjectValue.length > 0 ?
                                        (
                                            <>

                                                {
                                                    this.state.subjectValue.map((item, i) => {
                                                        let marks = this.state.marksArray.filter((item1) => item1.subject_id == item.value);
                                                        //console("marks", marks);
                                                        return (
                                                            <>
                                                                <Form.Group as={Col} lg={3} md={12} sm={12} className="mb-2">
                                                                    <p>{item.label} Marks</p>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder=""
                                                                        name="termsFeeInput"
                                                                        autoComplete="off"
                                                                        className='custom_selection'
                                                                        onChange={(e) => this.handleMarksChange(e, item.value)}
                                                                        value={marks[0].total_marks}
                                                                        min="1"
                                                                    />
                                                                </Form.Group>
                                                            </>
                                                        )
                                                    })
                                                }
                                                <Form.Text className="form-text text-danger">
                                                    {this.state.marksError}
                                                </Form.Text>
                                            </>
                                        )
                                        :
                                        ("")
                                }
                            </Form.Row>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Row>
                            <Col sm={12} className="text-center">
                                <Button onClick={(e) => this.handleFormSubmit()} className="examPattern_btn" disabled={this.state.isSubmitting} style={this.state.isSubmitting == true ? { cursor: "not-allowed" } : { cursor: "pointer" }}>
                                    {
                                        this.state.loadingSpinner == 1 ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : ""
                                    }
                                    Submit</Button>

                                <div>
                                    {this.state.currentStep == 5 ? (
                                        <Form.Text className="form-text text-danger mb-2">
                                            Pattern Saved successfully
                                        </Form.Text>
                                    ) : (
                                        <Form.Text className="form-text text-danger mb-2" >
                                            {this.state.submitError}
                                        </Form.Text>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                {/* Sibling of the form Modal (not nested) so it can stack above it when a
                submit is intercepted. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </>
        );
    }
}

export default graphql(ADD_EXAM_CATEGORY, {
    name: "addExamCategory"
})(CreateExamCategory);
